import { render, staticRenderFns } from "./playBlack.vue?vue&type=template&id=45dbd7e1"
import script from "./playBlack.vue?vue&type=script&lang=js"
export * from "./playBlack.vue?vue&type=script&lang=js"
import style0 from "./playBlack.vue?vue&type=style&index=0&id=45dbd7e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports